import {
  CreateArtworkCollectionType,
  CreateArtworkCollectionTypes,
} from "./data";

const setStateValue = (
  key: CreateArtworkCollectionTypes,
  value: any,
): CreateArtworkCollectionType => ({
  type: key,
  payload: value,
});

export const CreateCollectionActions = {
  setStateValue,
};
